import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation UserLesson_updateAttendance($lessonId: ID!, $userAttendance: [UserAttendance]) {
    UserLesson_updateAttendance(lessonId: $lessonId, userAttendance: $userAttendance)
  }
`;

const UserLessonUpdateAttendance = async ({ lessonId, userAttendance }) =>
  graphql(mutation, {
    lessonId,
    userAttendance,
  }).then(
    // eslint-disable-next-line camelcase
    ({ UserLesson_updateAttendance }) => UserLesson_updateAttendance
  );

export default UserLessonUpdateAttendance;
